import React, {useEffect, useRef, useState} from 'react';
import {Popup} from 'devextreme-react/popup';
import Form, {FormRef, GroupItem, Label, SimpleItem} from "devextreme-react/form";
import useCustomDataSource, {Mode} from "../../../hooks/useCustomDataSource";
import ILangue from '../../../models/ILangue';
import useApi from '../../../hooks/useApi';
import {Button} from 'devextreme-react/button';

export default function DefinitionColonnesDePlansParDefaut() {
    const colonnesFormDataSource = useCustomDataSource<any, any>({path: "langue", primaryKey: "idLangue"});
    const {setMainForm, selectedDataRow: colonnesApplication, setIsFieldModifier, mode, setSelectedDataRow, setMode, isFieldModifier, onFieldDataChanged} = colonnesFormDataSource;
    const formRef = useRef<FormRef>(null);
    const [isPopupVisible, setPopupVisibility] = useState(true);

    const {
        getData: getConfig,
    } = useApi('Configuration');

    useEffect(() => {
        try {
            const id = '00000000-0000-0000-0000-000000000000'
            getConfig({customPath: `PlanEntete/getPlanEnteteParametreRequis/${id}`})
                .then((result) => {
                    console.log(result)
                    setSelectedDataRow((prev: any) => {
                        if (!result || typeof result !== "object")
                            return prev;
                        return {...prev, ...result}
                    })
                })
                .catch((err) => console.log(err))
        } catch (error) {
        }
    }, [])

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (mode != Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
    }, [mode])

    const togglePopup = () => {
        setPopupVisibility(!isPopupVisible);
    };

    const onSelectionchanged = (item: any, e: string) => {
        setIsFieldModifier(true);
        setSelectedDataRow((prev: any) => {
            return {...prev, [e]: item.id}
        })
    }

    return (
        <Popup
            visible={isPopupVisible}
            // visible={this.state.popupVisible}
            // onHiding={this.hideInfo}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            title="Liste des arrivées"
            container=".dx-viewport"
            maxWidth={550}
        >
            <div className='wrapper-content-pop'>
                <div style={{maxWidth: '100px'}}>
                    <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={colonnesApplication || {} as ILangue} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                        <GroupItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text='Catégorie de client'></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text='Date de début et de fin'></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text='Description française et anglaise (utilisé sur le web)'></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text='Durée'></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text='Jours de semaine'></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Montant d'hébergement taxable"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Nombre d'adultes"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Nombre d'enfants"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Permettre autant d'enfants que d'adultes avant de charger des enfants additionnels"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Statut Membre"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Statut Résident"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Type d'Équipement"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Type (requis pour grouper dans le rapport d'hébergement annuel)"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Unité"></Label>
                            </SimpleItem>
                            <SimpleItem key={"frm-"} dataField={""} editorType='dxCheckBox'>
                                <Label location='right' showColon={false} text="Tranches d'âge"></Label>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                </div>
                <div className='content-footer-pop'>
                    <div className='footer-row-check-box'>
                        <div className='footer-button'>
                            <div>
                                <Button
                                    text="Appliquer"
                                    type="normal"
                                    // elementAttr={buttonAttributes}
                                    onClick={() => console.warn()}
                                />
                                <Button
                                    text="Annuler"
                                    type="normal"
                                    onClick={togglePopup}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
}